export const SIGNUP_REQUEST = 'SIGNUP_REQUEST';
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN = 'LOGIN';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT = 'LOGOUT';
export const REHYDRATE_AUTH = 'REHYDRATE_AUTH';
export const REHYDRATE_COMPLETE = 'REHYDRATE_COMPLETE';